// Import library countup.js
import { CountUp } from 'countup.js';

function makeCountup(el) {

    const number = el.innerText;
    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (entry.intersectionRatio > 0) {

                // if number decimal
                if (number % 1 != 0) {

                    const optionsdecimal = {
                        decimalPlaces: 2,
                        duration: 2,
                        separator: ' ',
                        decimal: ',',
                    };
                    let CountNumberDecimal = new CountUp(el, number, optionsdecimal);
                    CountNumberDecimal.start();
            
                } else {
            
                    const optionsnumber = {
                        duration: 2,
                        separator: ' ',
                    };
                    let CountNumber = new CountUp(el, number, optionsnumber);
                    CountNumber.start();

                }

                observer.unobserve(el);
                 
            }
        });
    });

    observer.observe(el);
}

const els = document.querySelectorAll('.js-countup');
els.forEach(makeCountup);


// Count numbers animation (OLD)
/*import anime from 'animejs';

function countup(el, target) {

    let data = { count: 0.00 };
    console.log(target + " azi c'est naze");

    anime({
        targets: data,
        count: [0, target],
        duration: 20000,
        round: 1.00,
        delay: 500,
        easing: 'easeInOutExpo',
        update() {
            el.innerText = data.count.toLocaleString('fr-FR');

            console.log(data.count.toLocaleString('fr-FR'));
        }
    });

}

function makeCountup(el) {
    const text = el.textContent;
    const target = parseFloat(text, 10);
    const io = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (entry.intersectionRatio > 0) {
                countup(el, target);
                io.unobserve(entry.target); 
            }
        });
    });

    io.observe(el);
}

const els = document.querySelectorAll('[data-countup]');
els.forEach(makeCountup);

*/
